import { createBrowserClient } from "@supabase/ssr";
import { SUPABASE_CONFIG } from "../config_client";

// For client components (browser) 
export const createBrowserSupabaseClient = () =>
  createBrowserClient(SUPABASE_CONFIG.url, SUPABASE_CONFIG.publishableKey, {
    auth: SUPABASE_CONFIG.auth,
  });

// Singleton for browser
export const browserClient = createBrowserSupabaseClient();

export default browserClient;